export abstract class Markers {
    public static readonly INTRO_1_MARKER: string = 'roadEdu-1';
    public static readonly INTRO_2_MARKER: string = 'roadEdu-2';
    public static readonly INTRO_3_MARKER: string = 'roadEdu-3';
    public static readonly ROAD_FINGER_MARKER: string = 'roadEdu-fingershown';
    public static readonly GOLD_MARKER: string = 'roadEdu-gold';
    public static readonly CRYSTAL_MARKER: string = 'roadEdu-cryst';
    public static readonly RESOURCES_GOT_MARKER: string = 'roadEdu-res-got';
    public static readonly CHEST_BY_PLANTS_MARKER: string = 'roadEdu-chest-by-plants';
    public static readonly VICTORY_FACT_MARKER: string = 'roadEdu-victory-fact';
    public static readonly GO_TO_WHITE_RABBIT_MARKER: string = 'roadEdu-good-luck';
    public static readonly ART_TAKEN_MARKER: string = 'roadEdu-art-taken';
    public static readonly HERO_VISITED_AFTER_PROMPT_MARKER = 'roadEdu-hero-visited';
    public static readonly ROAD_EDU_COMPLETED_MARKER = 'roadEdu-completed';

    public static readonly ART_UPDATE_STARTED_MARKER = 'art-edu-update-started';
    public static readonly ART_EDU_COMPLETED_MARKER = 'art-edu-completed';

    public static readonly USE_ROBOKASSA_MARKER = 'use-robokassa';
    public static readonly USE_XSOLLA_MARKER = 'use-xsolla';

    public static readonly MYTH_SEEN_MARKER = 'myth-seen';
    public static readonly TOP_SEEN_MARKER = 'top-seen';

    public static readonly CAS_SETTING_USER_CONSENT_STATUS_ACCEPT = 'cas-user-consent-status-accept';
    public static readonly CAS_SETTING_USER_CONSENT_STATUS_DECLINE = 'cas-user-consent-status-decline';
}
